import {
  IAccountProject,
  IAccountsProjects,
  typeThemeKeys,
  Themes,
  ProjectPickerStorageKeys,
  IAccount,
} from '@models';

export class ProjectPickerHelper {
  // get just the accounts
  static filterAccounts = (
    accountProjects: IAccountsProjects[]
  ): IAccount[] => {
    return accountProjects.map(
      (accountProject: IAccountsProjects): IAccount => accountProject.account
    );
  };
  // get the user's project history from localStorage
  static getHistory = (): IAccountProject[] => {
    const history = localStorage.getItem(
      ProjectPickerStorageKeys.lastUsedProjectHistory
    );
    if (history) {
      return JSON.parse(history);
    } else {
      throw new Error('no user project history found...');
    }
  };
  // get the first project from an accountProjectsList
  static getFirstProject = (
    accountId: string,
    accountProjectsList: IAccountsProjects[]
  ): IAccountProject => {
    const firstAccount = accountProjectsList.filter(
      ({ account: { accountId: id } }) => id === accountId
    )[0];

    if (firstAccount) {
      return firstAccount.projects[0];
    } else {
      throw new Error(
        'couldn`t find any the active account in the accounts list'
      );
    }
  };

  // get as single project from a project list
  static getProject = (projectId: string, projectList: IAccountProject[]) => {
    const project = projectList.filter(
      ({ projectId: id }) => projectId === id
    )[0];
    if (project) {
      return project;
    } else {
      throw new Error(`couldn't find projectId in projectList`);
    }
  };
  // get a single account by accountId
  static getAccountById = (
    accountId: string,
    projectsList: IAccountProject[]
  ): IAccountProject => {
    const account = projectsList.filter(
      ({ accountId: id }) => accountId === id
    )[0];
    if (account) {
      return account;
    } else {
      throw new Error(
        'failed to get account by accountId in the accounts list'
      );
    }
  };
  // sort single account projects by brand
  static sortProjectsByBrand = (
    projects: IAccountProject[]
  ): IAccountProject[][] => {
    if (projects.length > 0) {
      const brands: IAccountProject[][] = [];
      const brandKeys = Object.keys(Themes) as typeThemeKeys[];
      for (let keys in brandKeys) {
        const projectsByBrand = projects.filter(
          (project) => project.brand === brandKeys[keys]
        );
        if (projectsByBrand.length > 0) {
          brands.push(projectsByBrand);
        }
      }
      return brands;
    } else {
      throw new Error('no projects in the provided array');
    }
  };
  // sort multi account projects by brand
  static sortMultiAccountProjectsByBrand = (
    accountProjectsList: IAccountsProjects[]
  ): IAccountProject[][] => {
    const projects = accountProjectsList.flatMap(({ projects }) => projects);
    const brandKeys = Object.keys(Themes) as typeThemeKeys[];
    const brands: IAccountProject[][] = [];
    for (let keys in brandKeys) {
      const projectsByBrand: IAccountProject[] = projects.filter(
        (project) => project.brand === brandKeys[keys]
      );
      brands.push(projectsByBrand);
    }
    return brands;
  };
  // get projects by brand
  static getProjectsByBrand = (
    // selectAccountId: string,
    projectsList: IAccountProject[]
  ): IAccountProject[][] | false => {
    try {
      // sort the projects for the account by brand
      return ProjectPickerHelper.sortProjectsByBrand(projectsList);
    } catch (e) {
      console.error(e);
      console.error('something went wrong during the formatting process');
      return false;
    }
  };
  // search for the last used project by accountId (optional)
  // pulls all projects used by user in the localStorage
  // searches for the first project that matches the accountId
  static findLastUsedProject = (accountId: string): IAccountProject => {
    // get the historical list from user's localStorage
    const historical = ProjectPickerHelper.getHistory();

    const lastUsedProject = historical
      .reverse()
      .filter(({ accountId: id }) => accountId === id)[0];

    if (!lastUsedProject) {
      // IF - couldn't find the last used project for the account return the last
      throw new Error(
        `couldn't find a lastUsedProject in the history in the user's localStorage`
      );
    } else {
      return lastUsedProject;
    }
  };

  static doesProjectExistInAccount = (
    projectId: string,
    accountList: string
  ) => {};

  // get a project by a projectId
  // static getProjectByProjectId = (
  //   projectId: string,
  //   accountId: string,
  //   accountProjectsList: IAccountsProjects[]
  // ): IAccountProject => {
  //   // get the account
  //   const account = ProjectPickerHelper.getAccountById(
  //     accountId,
  //     accountProjectsList
  //   );
  //   // return the project
  //   return ProjectPickerHelper.getProject(projectId, account.projects);
  // };
}
